export default __webpack_public_path__ + "static/media/entity-coref-span-type.091e0692.gif";